<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Verificación en dos pasos</b-card-header>
      <b-card-body>
        <div class="row form-group">
          <div class="col-md-12 text-center">
            <img
              src="/img/icons/verificado.png"
              class="rounded-circle"
              style="width: 150px; cursor: pointer"
              alt
            />
          </div>
        </div>
        <div class="row form-group">
          <div
            class="col-md-12 text-center"
          >Activá al menos uno de los siguientes métodos de seguridad en dos pasos para reestablecer o modificar tus datos personales</div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Métodos de verificación</label>
            <div style="background-color: white; border-radius: 5px; border: #d6d4d4 1px solid">
              <div
                class="row"
                v-for="item in metodosVerificacion"
                v-bind:key="item.EntityID"
                :value="item.Name"
                style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
              >
                <div class="col-10" style="display: flex">
                  <img :src="getImgUrl(item.Icon)" style="width: 50px" alt />
                  <div class="bold" style="margin-left: 10px;">
                    <div>
                      <b>{{item.Name}}</b>
                    </div>
                    <div>{{item.ValueToShow}}</div>
                  </div>
                </div>
                <div class="col-2 text-right" style="padding-top: 10px; padding-right: 25px">
                  <resimple-switch
                    class="ml-2"
                    v-model="item.Enabled"
                    v-on:change="itemClicked(item)"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-12 text-center" style="margin-top:50px">
              <b-button class="btn btn-danger" @click="btnFinishClick">Finalizar</b-button>
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
</style>

<script>
import Vue from "vue";
import ResimpleSwitch from "@/components/Custom/ResimpleSwitch";
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
  components: { "resimple-switch": ResimpleSwitch },
  props: {
    verificationMethodItemProp: Object
  },
  data() {
    return {
      verificationMethodItem: this.verificationMethodItemProp,
      model: { Email: "" },
      enabled: false,
      metodosVerificacion: [],
      metodo: "",
      isPhoneVerify: false
    };
  },

  methods: {
    btnFinishClick() {
      this.$router.push("dashboard");
    },
    getImgUrl(pic) {
      return "/img/icons/" + pic;
    },
    gestionarMetodosVerificacion() {
      this.$router.push("metodosverificacion");
    },
    async doSleep(item) {
      await this.sleep(2000);
      item.Enabled = true;
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    itemClicked(item) {
      let context = this;

      var activo = false;
      for (let i = 0; i < context.metodosVerificacion.length; i++) {
        if (context.metodosVerificacion[i].Enabled == true) {
          activo = true;
        }
      }

      if (activo == false) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "Debe tener algún método de verificación activo",
          context
        );
        context.doSleep(item);
        return;
      }

      // -- Si uso la verificación en 2 pasos no la ejecutamos
      // if (context.$store.getters.useTwoStepsTwoStepVerification) {
        context.SaveVerificationMethod(context, item);
      // } else {
      //   context.$router.push({
      //     name: "InitialSelectSecurityMethod",
      //     params: {
      //       accumulationMethodTypeID: context.$store.getters.PERSONAL_DATA_UPDATE_ATTEMPTS_METHOD_TYPE_ID,
      //       useRouterPush: true,
      //       dataPost: {
      //         name: "InitialIdentityValidationTwoSteps",
      //         params: {
      //           verificationMethodItemProp: item
      //         }
      //       }
      //     }
      //   });
      // }
    },
    GetVerificationMethod() {
      let context = this;
      axiosHelpers.axiosGet(
        "VerificationMethod/GetInitialVerificationMethod",
        {},
        this,
        function(data) {
          context.metodosVerificacion = data.ResponseVM.Items;

          let updateAccountVerification = false;
          for (let i = 0; i < context.metodosVerificacion.length; i++) {
            if (context.metodosVerificacion[i].Enabled) {
              updateAccountVerification = true;
            }
          }

          if (updateAccountVerification) {
            context.$store.dispatch("updateAccountVerification", true);
          }
        }
      );
    },
    SaveVerificationMethod(context, item) {
      let req = {
        Enabled: item.Enabled,
        VerificationMethodID: item.EntityID,
        Value: item.Value
      };
      axiosHelpers.axiosPostWithOutSecurityValidations(
        "VerificationMethod/InitialVerificationMethodByAccount",
        req,
        context,
        function(data) {
          let itemGuardado = data.ResponseVM;

          context.$store.dispatch(
            "updateAccountVerification",
            itemGuardado.AccountVerificationEnabled
          );

          context.GetVerificationMethod();
        }
      );
    }
  },
  beforeMount: function() {
    var context = this;

    if (context.verificationMethodItem !== undefined) {
      context.SaveVerificationMethod(context, context.verificationMethodItem);
    } else {
      context.GetVerificationMethod();
    }
  }
};
</script>